"use client";

import { useRouter } from "next/navigation";

type HistoryBackLinkProps = {
  className?: string;
  label?: string;
  fallbackHref?: string;
};

export function HistoryBackLink({
  className,
  label = "← Back",
  fallbackHref = "/",
}: HistoryBackLinkProps) {
  const router = useRouter();

  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        if (typeof window !== "undefined" && window.history.length > 1) {
          router.back();
          return;
        }
        router.push(fallbackHref);
      }}
    >
      {label}
    </button>
  );
}
